import { mapGetters } from 'vuex';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import urlMixin from '@/common/mixins/url.js';
import guideArticleCard from '@/guide/components/guidearticlecard/guidearticlecard.vue';
import guideArticleContent from '@/guide/components/guidearticlecontent/guide-articlecontent.vue';
import guideArticleListingSeo from '@/guide/components/guidearticleseo/guide-listingseo.vue';
import guideArticleNearBySeo from '@/guide/components/guidearticleseo/guide-nearbyseo.vue';
import guideAuthorInfo from '@/guide/components/guideauthorinfo/guide-authorinfo.vue';
import guideNavigation from '@/guide/components/guidenavigation/guide-navigation.vue';
import guideWelcome from '@/guide/components/guidewelcome/guide-welcome.vue';
import cardSection from '@/market-trends/components/cardsection/card-section.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'articleThemeOne',
    props: ['type'],
    components: {
        guideWelcome,
        guideArticleCard,
        guideAuthorInfo,
        guideNavigation,
        guideArticleContent,
        guideArticleNearBySeo,
        guideArticleListingSeo,
        cardSection,
        mvtNearby,
        mvtLazyload,
    },
    mixins: [lazyCarouselCheckMixin],
    computed: {
        ...mapGetters('glb', ['glb', 'getOfficeInfo']),
        ...mapGetters('guide', ['guide', 'relatedArticleCards', 'relatedArticleLinks']),
        officeData() {
            return this.getOfficeInfo[`${this.guide.geo.cityCode}-${this.guide.geo.stateCode}`];
        },
        path() {
            let path = urlMixin.methods.generateMapSearchUrl('', {
                type: 'city',
                cityName: this.glb.geo.city,
                stateCode: this.glb.geo.stateCode,
                filterArray: ['condo'],
            });
            return {
                condo: (path.filteredUrlObj && path.filteredUrlObj.condo) || '',
                city: (this.glb.geo && this.glb.geo.cityPath) || '',
            };
        },
    },
    methods: {
        completed() {
            this.$refs.lazyloadNearby && this.$refs.lazyloadNearby.ready();
            this.$refs.lazyloadNearbyCondos && this.$refs.lazyloadNearbyCondos.ready();
        },
    },
};